<div class="label justify-end">
  {{
    'communication.message.system.cases.sub-type-changed'
      | translate: { old: this.case().OldSubType ?? '', new: this.case().NewSubType ?? '' }
  }}
</div>
